jQuery(document).ready(function($) {
	$('.gallery_carousel_wrap').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		prevArrow: '<div class="slick-nav-prev"><img src="/wp-content/themes/DailyPress/assets/images/arrow_left.webp" alt="Previous" /></div>',
		nextArrow: '<div class="slick-nav-next"><img src="/wp-content/themes/DailyPress/assets/images/arrow_right.webp" alt="Next" /></div>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	
	
	function initCarouselLightbox(parentClass) {
		if(typeof parentClass === 'undefined' || !parentClass) return; //early return if parentClass is undefined

		jQuery('.gallery_carousel_item').on('click', function(){
			var index = jQuery(this).data('index');
			var lightbox = jQuery(this).parents(parentClass).find('.gallery__lightbox');

			lightbox.addClass('active');
			setTimeout(function() { //strangely needs timeout to works
				lightbox.find('.lightbox').slick('slickGoTo', index, true);
			}, 10);

			jQuery('html').css('overflow-y', 'hidden');
			jQuery('body').css('overflow-y', 'hidden');
		});

		jQuery('.gallery__lightbox--close').on('click', function(){
			jQuery(this).parent().removeClass('active');

			jQuery('html').css('overflow-y', 'auto');
			jQuery('body').css('overflow-y', 'auto');
		});

		//Main Slider
		jQuery('.gallery__lightbox .lightbox').slick({
			slidesToShow: 1,
			infinite: false,
			dots: false,
			lazyLoad: 'ondemand',
			arrows: false
		});

		//Navigation Slider
		jQuery('.gallery__lightbox .lightbox-navigation').slick({
			slidesToShow: 3,
			infinite: false,
			dots: false,
			centerMode: true,
			focusOnSelect: true,
			arrows: true,
			swipeToSlide: true,
			prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
			nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
			asNavFor: '.gallery__lightbox .lightbox',
			responsive: [
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 3,
					}
				}
			]
		});
	}
	initCarouselLightbox('.gallery_carousel');
});